import { FC } from 'react';
import { Link } from '@tanstack/react-router';
import { ArrowRight } from 'lucide-react';
import { cn } from '@new/lib';

const COURSE_BUILDER_ROUTE = '/course-builder';
const TRANSFERRED_COLOR = 'bg-(--secondary-B900)';
const NEWLANE_COLOR = 'bg-(--primary-O900)';
const NO_PLAN_HINT =
  'Build your course plan to see exactly how these credits count toward this degree.';

interface NoPlanCreditsSummaryProps {
  transferredCredits: number;
  newlaneCredits: number;
}

interface CreditStatProps {
  label: string;
  credits: number;
  color: string;
}

const CreditStat: FC<CreditStatProps> = ({ label, credits, color }) => (
  <div className="flex items-center gap-2">
    <span aria-hidden className={cn('size-2 rounded-sm!', color)} />
    <span className="l5 text-(--neutral-black-NB600)">{label}</span>
    <span className="p3 semibold text-(--neutral-black-NB900)">{credits}</span>
  </div>
);

export const NoPlanCreditsSummary: FC<NoPlanCreditsSummaryProps> = ({
  transferredCredits,
  newlaneCredits,
}) => (
  <div className="flex flex-col gap-3 border-b border-(--neutral-black-NB200) bg-(--primary-O100) px-5 py-5 sm:px-7">
    <span className="l5 medium text-(--neutral-black-NB700)">Degree progress</span>

    <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
      <CreditStat
        label="Transferred credits"
        credits={transferredCredits}
        color={TRANSFERRED_COLOR}
      />
      <CreditStat label="Taken on Newlane" credits={newlaneCredits} color={NEWLANE_COLOR} />
    </div>

    <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
      <p className="l5 m-0! text-(--neutral-black-NB600)">{NO_PLAN_HINT}</p>
      <Link
        to={COURSE_BUILDER_ROUTE}
        className="inline-flex shrink-0 items-center gap-1.5 l5 bold text-(--primary-O900)! hover:underline"
      >
        Build my plan
        <ArrowRight aria-hidden className="size-4" />
      </Link>
    </div>
  </div>
);
